'use strict';

import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';
export default (function () {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      ref = _useState2[0],
      setRef = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      inView = _useState4[0],
      setInView = _useState4[1];

  useEffect(function () {
    var elementYPos = function elementYPos() {
      return ref.getBoundingClientRect().top + window.pageYOffset - window.innerHeight + offset;
    };

    if (!ref) {
      return;
    }

    var handleScroll = throttle(function () {
      if (!ref) {
        return;
      }

      if (window.pageYOffset >= elementYPos()) {
        window.removeEventListener('scroll', handleScroll);
        setInView(true);
      }
    }, 200);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, [ref, offset]);
  return [setRef, inView];
});